var FcOutlinedInputModule = /** @class */ (function () {
    function FcOutlinedInputModule() {
    }
    return FcOutlinedInputModule;
}());
export { FcOutlinedInputModule };
